module.exports = __webpack_public_path__ + "static/media/CMEC_logo_PMS.cd7edd90.jpg";